console.log("init application.ts")

import Vue, { ComponentOptions, VNode, VueConstructor } from 'vue';
import Component from 'vue-class-component';

@Component({
    template: `
  <v-app>
    <v-navigation-drawer v-model="drawer" app clipped >
      <v-list dense>
        <v-list-item link to="/">
          <v-list-item-action>
            <v-icon>mdi-view-dashboard</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Home</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <!--
        <v-list-item link>
          <v-list-item-action>
            <v-icon>mdi-cog</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Settings</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        -->
        <v-list-item link to="/about">
          <v-list-item-action>
            <v-icon>mdi-account</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>About</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>

    <v-app-bar app clipped-left>
      <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
      <v-toolbar-title>Graphviewer</v-toolbar-title>
    </v-app-bar>

    <v-main >
        <div style="background-color: white; position: absolute; left: 0; top: 0; right: 0; bottom: 0; padding: 1rem;">
            <router-view></router-view>
        </div>
    </v-main>

    <v-footer app>
      <span>&copy; 2020 <a href="https://stepanrutz.com" target="_blank">Stepan Rutz</a> / stepan.rutz AT gmx.de</span>
    </v-footer>
  </v-app>`,
})
export class Application extends Vue {

    static instance : Application

    drawer = false

    created() {
        this.$vuetify.theme.dark = false
    }

    onAbout() {
        //this.$router.push("/about")
    }
}

